import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import { fg } from '@townsquare/stat-sig/gate';

import GoalViewHeaderQuery, {
	type GoalHeaderRefreshedQuery as GoalHeaderRefreshedQueryType,
} from '../components/GoalHeaderRefreshed/__generated__/GoalHeaderRefreshedQuery.graphql';

export const goalViewHeaderResource: RouteResource<
	PreloadedQuery<GoalHeaderRefreshedQueryType, Record<string, unknown>>
> = createRelayResource<GoalHeaderRefreshedQueryType>({
	getQuery: (routerContext) => {
		return {
			query: GoalViewHeaderQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				trackViewEvent: 'DIRECT',
				goalUpdateDraftsEnabled: fg('townsquare_goal_update_drafts'),
			},
		};
	},
});
